<template>
  <div class="page">
    <div class="bg-fx" aria-hidden="true">
      <div class="stars"></div>
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
      <div class="orb orb-4"></div>
    </div>
    <div class="scanline" aria-hidden="true"></div>

    <header class="page-header">
      <img src="../assets/logo.png" class="logo" @click="gourl" alt="logo">
      <div class="language">
        <swithLanguage></swithLanguage>
      </div>
    </header>

    <main class="page-main">
      <div class="card cyber-card">
        <span class="card-corner tl" aria-hidden="true"></span>
        <span class="card-corner tr" aria-hidden="true"></span>
        <span class="card-corner bl" aria-hidden="true"></span>
        <span class="card-corner br" aria-hidden="true"></span>
        <div class="card-glow" aria-hidden="true"></div>

        <div class="card-inner">
          <div class="slogan-wrap">
            <h1 class="slogan neon-text" @click="test">{{ $t('index.slogan') }}</h1>
            <div class="slogan-line" aria-hidden="true"></div>
          </div>
          <p class="subtitle">{{ $t('index.customText') }}</p>

          <div class="form-section">
            <div class="input-group">
              <input v-model="password" class="input" :placeholder="$t('index.placeholder')">
              <input v-model="password_user" type="password" class="input" :placeholder="$t('index.placeholder_user')">
            </div>

            <div class="platform-group">
              <span class="platform-label">Platform</span>
              <div class="platform-options">
                <el-radio v-model="radio" class="platform-radio" label="tiktok" border>TikTok</el-radio>
                <el-radio v-model="radio" class="platform-radio" label="bigo" border>bigo</el-radio>
              </div>
            </div>

            <el-button @click="go" type="primary" size="large" color="#636ff1" class="submit-btn">
              {{ $t('index.goButton') }}
            </el-button>
          </div>
        </div>
      </div>
    </main>

    <!-- <footer class="bottom">
      星遇互游 © 2024 All Rights by 湖北千纳文化发展有限公司.<br>
      鄂ICP备2021020027号-1
    </footer> -->
  </div>
</template>

<script>
import { ElLoading, ElMessage } from 'element-plus'
import { post } from "@/api";
import swithLanguage from "@/components/swithLanguage.vue";

export default {
  name: 'HelloWorld',
  components: { swithLanguage },
  data() {
    return {
      password: "",
      options: [],
      value: '',
      password_user: "",
      radio: "tiktok"
    }
  },
  created() {

    if (window.localStorage.getItem("platform")) {
      this.radio = window.localStorage.getItem("platform")
    }

    if (this.$route.query.user) {
      this.password = this.$route.query.user
      if (this.$route.query.key) {
        this.get(this.$route.query.key);
      }
    } else if (this.$route.query.anchor_user && this.$route.query.anchor_password) {
      this.password = this.$route.query.anchor_user
      this.password_user = this.$route.query.anchor_password
      this.go()
    }

    console.log(this.$route.query)
  },
  methods: {
    test() {
      // window.chrome.webview.postMessage(JSON.stringify({
      //   type: "openNewTool", key: "N493euAgQqPqOmr6q0d7jwQEtAmouE8+d58r7lMe5sg=", token: "tool_74657374303032333a313735333236303530373a616e74695f63686561745f746f6f6c",
      // }));
    },
    get(key) {
      post("/get_role", {
        "user": this.password,
        "key": key
      }).then(res => {
        if (res.code == 200) {
          this.password_user = res.data
        }
        console.log(res)
      }).catch(res => {
        console.log(res)
      })
    },
    go() {

      if (!this.radio) {
        ElMessage.error(this.$t('notify.platformNULL'))
        return;
      }
      if (!this.password || !this.password_user) {
        ElMessage.error(this.$t('index.placeholder'))
        return;
      }

      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      post("/login", {
        "user": this.password,
        "password": this.password_user,
        "platform": this.radio
      }).then(res => {
        loading.close()
        if (res.data["errorCode"] == 106 || res.code == 400 || res.data["errorCode"] == 1) {
          console.log(res.data)
          ElMessage.error(this.$t('newNotify.' + res.data["i18"]))
        } else if (res.data["errorCode"] == 0) {
          console.log(res.data)
          window.localStorage.setItem("platform", this.radio)
          window.localStorage.setItem("data", JSON.stringify(res.data))
          this.$router.push("/pay")
        }
      }).catch(res => {
        loading.close()
        ElMessage.error(this.$t('newNotify.networkError'))
        console.log(res)
      })
    },
    gourl() {
      window.location.href = "https://www.xyhy.live"
    }
  }
}
</script>

<style scoped>
.page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
}

.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 40px;
  position: relative;
  z-index: 10;
}

.logo {
  width: 160px;
  height: auto;
  cursor: pointer;
  transition: opacity var(--transition);
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.4));
}

.logo:hover {
  opacity: 0.85;
}

.language {
  position: static;
}

.page-main {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 24px 80px;
  position: relative;
  z-index: 5;
}

.card {
  width: 100%;
  max-width: 540px;
  animation: cardEnter 0.8s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes cardEnter {
  from {
    opacity: 0;
    transform: translateY(40px) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.card-inner {
  position: relative;
  padding: 48px 40px;
  text-align: center;
  z-index: 1;
}

.slogan-wrap {
  margin-bottom: 12px;
}

.slogan {
  font-size: 2.2rem;
  font-weight: 800;
  line-height: 1.2;
  cursor: pointer;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.slogan-line {
  width: 64px;
  height: 1px;
  margin: 14px auto 0;
  background: rgba(255, 255, 255, 0.15);
}

.subtitle {
  font-size: 14px;
  color: var(--text-secondary);
  font-weight: 500;
  margin-bottom: 36px;
  line-height: 1.6;
  letter-spacing: 0.02em;
}

.form-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
}

.input-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.input {
  width: 100%;
  height: 48px;
  padding: 0 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: var(--radius-sm);
  background: rgba(255, 255, 255, 0.04);
  color: var(--text-primary);
  font-family: inherit;
  font-size: 15px;
  outline: none;
  transition: border-color var(--transition), box-shadow var(--transition);
}

.input::placeholder {
  color: var(--text-muted);
}

.input:hover {
  border-color: rgba(255, 255, 255, 0.16);
}

.input:focus {
  border-color: rgba(129, 140, 248, 0.45);
  box-shadow: 0 0 0 2px rgba(129, 140, 248, 0.12);
}

.platform-group {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
}

.platform-label {
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.04em;
  color: var(--text-muted);
}

.platform-options {
  display: flex;
  gap: 12px;
  width: 100%;
}

.platform-radio {
  flex: 1;
  margin-right: 0 !important;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.platform-radio :deep(.el-radio__label) {
  color: var(--text-secondary) !important;
  font-weight: 500;
}

.submit-btn {
  width: 100%;
  height: 46px !important;
  margin-top: 8px;
  font-size: 15px !important;
  font-family: inherit !important;
  border-radius: var(--radius-sm) !important;
}

.bottom {
  color: var(--text-muted);
  font-weight: 500;
  font-size: 13px;
  text-align: center;
  padding: 24px;
  line-height: 1.6;
}
</style>
